import { render, staticRenderFns } from "./PatientDetailsCard.vue?vue&type=template&id=797c21c8&scoped=true"
import script from "./PatientDetailsCard.vue?vue&type=script&lang=js"
export * from "./PatientDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailsCard.vue?vue&type=style&index=0&id=797c21c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c21c8",
  null
  
)

export default component.exports